// TermsOfService.jsx (Example)
import React from 'react';
import './TermsOfService.css'

function TermsOfService() {
  return (
    <div className='terms-of-service'>
      <div style={{ padding: '2rem' }}>
      <h1>Terms of Service</h1>
      <p>
        <strong>Effective Date:</strong> January 1st, 2025
      </p>

      <p>
        Welcome to <strong>privateIQ</strong> (the “Site”), owned and operated by{" "}
        <strong>Non-Target LLC</strong>, located at 5511 Parkcrest Drive, Suite 103, #1000,
        Austin, TX 78731, United States (“we,” “us,” or “our”). By accessing or
        using this Site, you (the “User”) agree to be bound by these Terms of
        Service (“Terms”). If you do not agree to these Terms, you may not use the
        Site.
      </p>

      <h2>1. Acceptance of Terms</h2>
      <h3>1.1 Binding Agreement</h3>
      <p>
        These Terms constitute a legally binding agreement between you and
        Non-Target LLC. By accessing, browsing, or otherwise using the Site, you
        represent that you have read, understood, and agree to be bound by these
        Terms, as well as our{" "}
        <a href="privacypolicy">Privacy Policy</a>, which is
        incorporated herein by reference.
      </p>

      <h3>1.2 Eligibility</h3>
      <p>
        You affirm that you are either more than 18 years of age, or possess legal
        parental or guardian consent, and are fully able and competent to enter into
        these Terms. If you are using the Site on behalf of an organization, you
        represent and warrant that you have the authority to bind that organization
        to these Terms.
      </p>

      <h2>2. Modifications to the Terms</h2>
      <p>
        We reserve the right, at our sole discretion, to modify, update, or replace
        these Terms at any time. If we make material changes, we will provide notice
        (e.g., by posting a notice on the Site or sending an email). It is your
        responsibility to check the Site periodically for changes. Your continued use
        of the Site following any such change constitutes your acceptance of the
        revised Terms.
      </p>

      <h2>3. Description of Services</h2>
      <h3>3.1 General</h3>
      <p>
        privateIQ provides information and insights regarding private country clubs
        throughout the United States, including (but not limited to) club summaries
        and potential fees.
      </p>

      <h3>3.2 Accuracy of Information</h3>
      <p>
        We strive to provide accurate, up-to-date information and cite our sources
        wherever possible. However, due to the large volume of data (over 2,500
        clubs), <strong>we do not guarantee</strong> the completeness or accuracy of
        the information on the Site. Users should independently verify any details
        that may be important to their decision-making.
      </p>

      <h3>3.3 No Affiliation with Clubs</h3>
      <p>
        We are <strong>not affiliated</strong> with any of the country clubs listed
        on privateIQ and do not endorse or recommend any particular club. The
        information provided is for general informational purposes only.
      </p>

      <h3>3.4 Availability</h3>
      <p>
        We will make reasonable efforts to keep the Site operational. However,
        certain technical difficulties, routine site maintenance, or upgrades may
        result in temporary service interruptions. We reserve the right at any time
        to modify or discontinue, temporarily or permanently, the Site (or any part
        thereof) with or without notice.
      </p>

      <h2>4. User Accounts</h2>
      <h3>4.1 Account Creation</h3>
      <p>
        To access certain features of the Site, you may need to create an account.
        You agree to provide accurate, current, and complete information during
        registration and to keep this information up to date.
      </p>

      <h3>4.2 Account Security</h3>
      <p>
        You are responsible for maintaining the confidentiality of your login
        credentials and for all activities that occur under your account. You agree
        to notify us immediately of any unauthorized use of your account.
      </p>

      <h3>4.3 Suspension or Termination</h3>
      <p>
        We may suspend, disable, or delete your account at our sole discretion, with
        or without notice, for any or no reason, including if we believe you have
        violated these Terms or any applicable law.
      </p>

      <h2>5. User Conduct</h2>
      <h3>5.1 Prohibited Activities</h3>
      <p>When using the Site, you agree not to:</p>
      <ul>
        <li>Violate any applicable law or regulation;</li>
        <li>Infringe or violate the rights of any third party, including intellectual property, privacy, or contractual rights;</li>
        <li>Use the Site for any unauthorized purpose, or in connection with any commercial endeavors except those specifically approved by us;</li>
        <li>Upload or transmit any viruses, malware, or other malicious code;</li>
        <li>Engage in any activity that disrupts or interferes with the Site’s normal operation;</li>
        <li>Collect or harvest any personally identifiable information from other users, except as permitted under these Terms and applicable law.</li>
      </ul>

      <h3>5.2 Compliance with Laws</h3>
      <p>You are solely responsible for ensuring compliance with the laws of your specific jurisdiction.</p>

      <h2>6. Intellectual Property</h2>
      <h3>6.1 Ownership</h3>
      <p>
        All content, features, and functionality available on or through the Site —
        including but not limited to text, graphics, logos, icons, images, audio
        clips, video clips, data compilations, software, and the compilation thereof
        — are the exclusive property of Non-Target LLC and/or its licensors and are
        protected by U.S. and international intellectual property laws.
      </p>

      <h3>6.2 License and Access</h3>
      <p>
        We grant you a limited, non-exclusive, non-transferable license to access and
        make personal, non-commercial use of the Site. This license does not include
        any resale or commercial use of the Site or its contents without express
        written consent from us.
      </p>

      <h3>6.3 Trademarks</h3>
      <p>
        All trademarks, service marks, logos, and trade names associated with
        privateIQ or Non-Target LLC used on the Site are proprietary to Non-Target
        LLC or its licensors. You may not use these marks without our prior written
        permission.
      </p>

      <h2>7. User Content</h2>
      <h3>7.1 User Submissions</h3>
      <p>
        Certain features of the Site may allow you to submit, post, upload, or
        otherwise provide content (“User Content”). You retain any intellectual
        property rights you hold in that User Content.
      </p>

      <h3>7.2 License to User Content</h3>
      <p>
        By posting User Content, you grant us a worldwide, non-exclusive,
        royalty-free, sublicensable, and transferable license to use, reproduce,
        distribute, display, and perform such content in connection with the Site
        and our business, including for promotional and marketing purposes.
      </p>

      <h3>7.3 User Representations</h3>
      <p>
        You represent and warrant that you own or have the necessary rights to all
        User Content you provide and that our use of such User Content does not
        violate these Terms or infringe upon the rights of any person or entity.
      </p>

      <h2>8. Third-Party Links and Services</h2>
      <p>
        The Site may contain links to third-party websites or services that are not
        owned or controlled by Non-Target LLC. We have no control over, and assume no
        responsibility for, the content, privacy policies, or practices of any
        third-party websites or services. You acknowledge and agree that we are not
        liable for any damage or loss caused or alleged to be caused by or in
        connection with use of or reliance on any such third-party content.
      </p>

      <h2>9. Disclaimers</h2>
      <h3>9.1 No Warranty</h3>
      <p>
        YOUR USE OF THE SITE IS AT YOUR SOLE RISK. THE SITE IS PROVIDED “AS IS” AND
        “AS AVAILABLE” WITHOUT WARRANTY OF ANY KIND, WHETHER EXPRESS, IMPLIED, OR
        STATUTORY. WE DISCLAIM ALL WARRANTIES, INCLUDING BUT NOT LIMITED TO,
        WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, AND
        NON-INFRINGEMENT.
      </p>

      <h3>9.2 Data Accuracy</h3>
      <p>
        While we strive to provide accurate, up-to-date information on privateIQ,
        <strong> we make no guarantees or representations regarding the completeness,
        reliability, or accuracy</strong> of any data, including club summaries,
        fees, or other details. You acknowledge that there may be errors or omissions
        in the information presented.
      </p>

      <h3>9.3 No Affiliation or Endorsement</h3>
      <p>
        We do not endorse, sponsor, or have any formal relationship with any of the
        country clubs featured on the Site. The inclusion of any data or references
        does not imply endorsement or affiliation.
      </p>

      <h2>10. Limitation of Liability</h2>
      <p>
        TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, NON-TARGET LLC AND ITS
        AFFILIATES, DIRECTORS, OFFICERS, EMPLOYEES, AND AGENTS SHALL NOT BE LIABLE
        FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR EXEMPLARY DAMAGES,
        INCLUDING BUT NOT LIMITED TO DAMAGES FOR LOSS OF PROFITS, GOODWILL, USE,
        DATA, OR OTHER INTANGIBLE LOSSES, ARISING OUT OF OR IN CONNECTION WITH YOUR
        USE OF THE SITE OR RELIANCE ON ANY INFORMATION PROVIDED.
      </p>

      <h2>11. Indemnification</h2>
      <p>
        You agree to defend, indemnify, and hold harmless Non-Target LLC, its
        affiliates, and their respective officers, directors, employees, and agents,
        from and against any claims, liabilities, damages, losses, and expenses,
        including reasonable attorneys’ fees, arising out of or in any way connected
        with your access to or use of the Site, your violation of these Terms, or
        your infringement of any third-party right, including any intellectual
        property right or privacy right.
      </p>

      <h2>12. Termination</h2>
      <h3>12.1 Termination by You</h3>
      <p>
        You may discontinue your use of the Site at any time by closing your account
        (if applicable) and ceasing all access and use.
      </p>

      <h3>12.2 Termination by Us</h3>
      <p>
        We may terminate or suspend your access to the Site immediately, without
        prior notice or liability, for any reason whatsoever, including without
        limitation if you breach these Terms.
      </p>

      <h3>12.3 Effect of Termination</h3>
      <p>
        Upon termination of your account, your right to use the Site will immediately
        cease. All provisions of these Terms that by their nature should survive
        termination shall survive, including ownership provisions, warranty
        disclaimers, indemnity, and limitations of liability.
      </p>

      <h2>13. Governing Law and Dispute Resolution</h2>
      <h3>13.1 Governing Law</h3>
      <p>
        These Terms shall be governed by and construed in accordance with the laws of
        the State of Texas, without regard to its conflict of laws principles.
      </p>

      <h3>13.2 Dispute Resolution</h3>
      <p>
        Any dispute arising out of or relating to these Terms shall be resolved
        through litigation in Austin, Texas, and you consent to the personal
        jurisdiction of and venue in such courts.
      </p>

      <h2>14. Miscellaneous</h2>
      <h3>14.1 Entire Agreement</h3>
      <p>
        These Terms, along with our Privacy Policy and any additional agreements you
        may enter into with Non-Target LLC, constitute the entire agreement between
        you and Non-Target LLC regarding the Site.
      </p>

      <h3>14.2 Severability</h3>
      <p>
        If any provision of these Terms is held to be invalid or unenforceable, that
        provision will be enforced to the maximum extent permissible, and the
        remaining provisions shall remain in full force and effect.
      </p>

      <h3>14.3 No Waiver</h3>
      <p>
        No failure or delay by us in exercising any right hereunder shall operate as
        a waiver thereof, nor shall any partial exercise of any right or power
        preclude further exercise.
      </p>

      <h3>14.4 Assignment</h3>
      <p>
        You may not assign or transfer these Terms, by operation of law or otherwise,
        without our prior written consent. We may assign these Terms at our
        discretion without restriction.
      </p>

      <h3>14.5 Notices</h3>
      <p>
        Any notices or other communications provided by us under these Terms may be
        given via email or by posting on the Site. For notices made by email, the
        date of receipt is deemed the date on which such notice is transmitted.
      </p>

      <h2>15. Contact Information</h2>
      <p>
        If you have any questions about these Terms or wish to report violations,
        please contact us at:
      </p>
      <address>
        <strong>Non-Target LLC</strong>
        <br />
        5511 Parkcrest Drive, Suite 103, #1000
        <br />
        Austin, TX 78731
        <br />
        United States
        <br />
        <a href="mailto:support@privateIQ.golf">support@privateIQ.golf</a>
      </address>

      <p>
        <strong>
          BY USING THIS SITE, YOU ACKNOWLEDGE THAT YOU HAVE READ AND UNDERSTAND THESE
          TERMS, AND YOU AGREE TO BE BOUND BY THEM.
        </strong>
      </p>

      </div>
    </div>
  );
}

export default TermsOfService;
